import React from 'react';

interface InputTextProps {
  label: string;
  className: string;
  value: string;
  name: string;
  mandatory: boolean;
  changeState: (value: string) => void;
}
const InputText: React.FC<InputTextProps> = (props) => {
  return (
    <div className={props.className}>
      <label>
        {props.label} {props.mandatory && <span className="mandatory">*</span>}{' '}
      </label>
      <input
        type="text"
        className="input-form"
        name={props.name}
        value={props.value}
        onChange={(e) => props.changeState(e.target.value)}
      />
    </div>
  );
};

export default InputText;
